import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { InventoryEntry, Variant } from '../models/combined-interfaces.model';
import { AdminCommonHttpService } from '../service/admin-common-http.service';
import { CommonModule } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { EditVariantAttributesDialogComponent } from './edit-variant-attributes-dialog/edit-variant-attributes-dialog.component';


@Component({
  selector: 'app-variant-detail',
  templateUrl: './variant-detail.component.html',
  styleUrls: ['./variant-detail.component.scss'],
  standalone: true,
  imports: [BreadcrumbComponent, MatTab, MatTabGroup, CommonModule, MatFormField, MatSelect, MatOption, MatLabel, FormsModule]
})
export class VariantDetailComponent implements OnInit {
  productId!: number;
  variantId!: number;
  variantName: string | null = null;
  sku: string | null = null;
  productName: string | null = null;
  inventory: InventoryEntry[] = [];
  channels: { channel_code: string, display_name: string }[] = [];
  selectedChannel: string = '';
  variant: Variant | null = null;


  async ngOnInit(): Promise<void> {
    this.productId = Number(this.route.snapshot.paramMap.get('productId'));
    this.variantId = Number(this.route.snapshot.paramMap.get('variantId'));

    const nameFromQuery = this.route.snapshot.queryParamMap.get('variantName');
    this.variantName = nameFromQuery ? decodeURIComponent(nameFromQuery) : null;

    this.route.queryParamMap.subscribe(params => {
      this.productName = params.get('productName');
      this.variantName = params.get('variantName');
    });

    await this.loadInventory();

    await this.loadChannels();
    await this.loadVariant();
  }

  constructor(private route: ActivatedRoute, private commonApiService: AdminCommonHttpService, private dialog: MatDialog) { }

  getAttributeKeys(attrs: any): string[] {
    return attrs ? Object.keys(attrs) : [];
  }


  async loadInventory(): Promise<void> {
    try {
      this.inventory = await this.commonApiService.getInventoryByVariant(this.variantId);
    } catch (error) {
      console.error('Failed to load inventory:', error);
      this.inventory = [];
    }
  }

  async loadVariant(): Promise<void> {
    try {
      if (!this.variantId) return;
      this.variant = await this.commonApiService.getVariantById(this.variantId);
      this.sku = this.variant?.sku || null; // ✅ Add this
    } catch (error) {
      console.error('Failed to load variant:', error);
      this.variant = null;
    }
  }



  get filteredInventory(): InventoryEntry[] {
    if (!this.selectedChannel) return this.inventory;
    return this.inventory.filter(inv => inv.channel_code === this.selectedChannel);
  }

  async loadChannels(): Promise<void> {
    try {
      const response = await this.commonApiService.getAllChannels();
      this.channels = response;
    } catch (error) {
      console.error('Failed to load channels:', error);
    }
  }

  onChannelChange(): void {
    // This triggers change detection for filteredInventory
  }

  editAttributes(): void {
    const dialogRef = this.dialog.open(EditVariantAttributesDialogComponent, {
      data: { attributes: this.variant?.attributes ?? {} }
    });

    dialogRef.afterClosed().subscribe(async (updatedAttributes) => {
      if (updatedAttributes && this.variant) {
        this.variant.attributes = updatedAttributes;
        try {
          await this.commonApiService.updateVariantAttributes(this.variant.variant_id, updatedAttributes);
          console.log('Attributes updated successfully');
        } catch (err) {
          console.error('Failed to update attributes', err);
        }
      }
    });
  }
}
